import { useEffect, useMemo } from 'react';
import {
  fetchSpinsCount,
  selectRemainingSpinsCount,
  selectRemainingSpinsCountState,
} from '@bonanza-social/instant-wheel';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';

export const useWheelSpinsCount = () => {
  const dispatch = useDispatch();
  const wheelSpinsCount = useSelector(selectRemainingSpinsCount);
  const spinsCountDataState = useSelector(selectRemainingSpinsCountState);

  const returnObj = useMemo(() => {
    return { wheelSpinsCount, spinsCountDataState };
  }, [wheelSpinsCount, spinsCountDataState]);

  useEffect(() => {
    if (spinsCountDataState === 'idle') {
      dispatch(fetchSpinsCount());
    }
  }, [dispatch, spinsCountDataState]);

  return returnObj;
};
